// Mirrors the `collections` table's columns exactly, typing raw Supabase
// query results (see PatternRecord in pattern.model.ts for the same
// convention).
export interface CollectionRecord {
  id: string;
  user_id: string;
  name: string;
  created_at: string;
}

export interface StoredCollection {
  id: string;
  name: string;
}

export const rowToStoredCollection = (row: CollectionRecord): StoredCollection => ({
  id: row.id,
  name: row.name,
});
